import React from "react";
const ProfileCardModal = ({ openModal, handleCloseModal, children }) => {
  return (
    <>
      {openModal && (
        <>
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg mt-10  relative">
              {children}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProfileCardModal;
